<template>
  <div>
    <div class="editor-wrapper">
      <Toolbar :editor="editor" :mode="mode" :defaultConfig="toolBarConfig" class="editor-toolbar" />
      <Editor class="text-editor" :defaultConfig="editorConfig" :mode="mode" v-model="html" @onCreated="onCreated"
        @onChange="onChange" />
    </div>
    <div class="editor-wrapper">
      <h2 style="color: cornflowerblue;margin-top: 30px;margin-bottom: 30px;">预览</h2>
      <hr/>
      <div v-html="html" style="border: 1px dashed #999; padding: 10px;"></div>
    </div>
  </div>

</template>

<script>
// 引入核心组件
import { Toolbar, Editor } from '@wangeditor/editor-for-vue'
import { } from '@wangeditor/editor-for-vue'
// 引入样式，非常重要！
import '@wangeditor/editor/dist/css/style.css'

export default {
  name: 'WangEditorV5',
  components: { Editor, Toolbar },
  // 接收父组件传入的内容，实现 v-model
  props: {
    value: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: ''
    },
    server: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      editor: null, // 存储 Editor 实例
      html: this.value, // 编辑器内容
      mode: 'simple', // 或 'simple'
      toolBarConfig: {
        excludeKeys: ['fullScreen', "insertVideo", "uploadVideo", "editVideoSize", "insertImage", "insertTable", "deleteTable", "insertTableRow", "deleteTableRow", "insertTableCol", "deleteTableCol", "tableHeader", "tableFullWidth"]
      },
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            server: 'https://api.tl2001.tourling.com/api/client/WEUploadCampPic', // 实际的图片上传接口
            fieldName: 'file',
            maxNumberOfFiles: 1,
            maxFileSize: 10 * 1024 * 1024, // 10MB
            headers: {
              'X-Token': this.token
            },
          }
        }
      }
    }
  },
  watch: {
    // 监听 prop value 的变化，当父组件更新内容时，同步到编辑器
    value(newVal) {
      if (newVal !== this.html) {
        this.html = newVal
      }
    },
    // 监听编辑器内部内容的变化，同步到父组件
    html(newVal) {
      this.$emit('input', newVal)
    }
  },
  beforeDestroy() {
    // 组件销毁时，销毁 editor 实例，非常重要！
    const editor = this.editor
    if (editor == null) return
    editor.destroy()
  },
  methods: {
    // Editor 实例创建完成后的回调函数
    onCreated(editor) {
      this.editor = Object.seal(editor) // 存储 editor 实例
    },
    // 内容变化时的回调函数 (可选，因为 v-model 已经处理了数据同步)
    onChange(editor) {
      console.log('内容已变化:', editor)

    }
  }
}
</script>

<style scoped>
.editor-wrapper {
  display: inline-block;
  vertical-align: top;
  margin-left: 100px;
  border: 1px solid #ccc;
  z-index: 1000;
  height: 600px;
  width: 400px;
  /* 确保工具栏和菜单的 z-index 足够高 */
}

/* 设置编辑器的高度 */
.text-editor {
  height: 450px;
  overflow-y: hidden;
  /* 隐藏编辑器的滚动条 */
}

.editor-toolbar {
  border-bottom: 1px solid #ccc;
}
</style>